import styled from "vue-styled-components";

const wishListProps = {
    isFavorite: {
        type: Boolean,
        default: false
    },
    showShadow: {
        type: Boolean,
        default: true
    },
    activeIconWishlist: {
        type: Boolean,
        default: true
    }
}

export const CWishList = styled('i', wishListProps)`
    text-shadow:${props => props.showShadow ? '2px 3px 8px #d44a25' : 'none'};
    opacity:${props => props.isFavorite ? '1' : '0'};
    color:${props => props.theme.primary_color+' !important'};
    display:${props => props.activeIconWishlist ? '': 'none'};

    /* position: absolute;
    display: flex;
    font-size: 1.8rem;
    margin: 0 2px;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    opacity: 1;
    z-index: 1;
    right: 5px; */
`;
